module.exports = __webpack_public_path__ + "static/usa-map-dot-mosaic.7864b5c5.svg";